import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'

export const patientWeightQueries = {
  forList: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientWeight'] } },
      query: db
        .selectFrom('patientWeight')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .orderBy('activeFrom', 'desc'),
    }),
}
